enum AmountType {
    TASK_CATEGORY = 'task_category',
    MANUAL_AMOUNT = 'manual_amount',
    STRIPE_INVOICE = 'stripe_invoice',
}

export default AmountType;
